import type { AwsRum } from 'aws-rum-web';
/**
 * This file is ignored by test coverage due to the difficulty of testing the dynamic import
 * The only logic it should have is the import statement.
 * Everything else should be in `awsrum.ts`
 */
const APP_VERSION = '1.0.0';
const AWS_REGION = 'us-east-1';
const RUM_ENDPOINT = `https://dataplane.rum.${AWS_REGION}.amazonaws.com`;

export type PartialRUMConfig = {
    applicationId: string;
    rumGuestRoleArn: string;
    identityPoolId: string;
};

export const initializeAWSRum = async (partialConfig: PartialRUMConfig): Promise<AwsRum> => {
    const { applicationId, identityPoolId, rumGuestRoleArn } = partialConfig;

    // Since the library is only used client side and is big (>100kb) we download it asynchronously
    const client = await import('aws-rum-web').then(({ AwsRum }) => {
        const awsRum = new AwsRum(applicationId, APP_VERSION, AWS_REGION, {
            sessionSampleRate: 0.02, // 2% of sessions, same as Datadog sampling rate
            guestRoleArn: rumGuestRoleArn,
            identityPoolId,
            endpoint: RUM_ENDPOINT,
            telemetries: ['performance', 'errors', 'http'],
            enableXRay: true,
        });
        window.onerror = (message) => {
            awsRum.recordError(message);
        };
        return awsRum;
    });

    return client;
};
